import styled from "styled-components";
import Example from "../assets/profile.png";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;

  button {
    background-color: inherit;
    border: none;
    font-weight: 500;
    color: var(--color-main-text);
    cursor: pointer;
    line-height: 60px;
    &:disabled {
      color: orange;
      text-decoration: underline;
      text-underline-offset: 15px;
      transition: 0.5s ease;
      background: red;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
`;

export const ProjectCells = styled.div`
  width: 100%;
  text-align: left;
  cursor: pointer;
  position: relative;
  /* padding: 20px; */
  box-sizing: border-box;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  aspect-ratio: 4 / 5;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }

  p {
    font-size: clamp(16px, 2.5vw, 20px);
    color: var(--color-main-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    margin-top: -30px;
  }

  h3 {
    font-size: clamp(14px, 2vw, 16px);
    font-weight: 500;
    color: var(--color-main-text);
    margin-top: 30px;
  }
`;

export const ProjectImage = styled.div`
  background-image: url(${Example});
  height: 500px;
  width: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
`;

export const ProjectContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  row-gap: 50px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  transition: 0.5s ease-in-out;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    padding: 0 !important;
  }
`;

export const HoverEffect = styled.a`
  position: absolute;
  width: 100%;
  height: 85%;
  background: radial-gradient(
    circle,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.5s ease-in-out;
  border-radius: 20px;
`;
export const Circle = styled.div`
  height: 70px;
  width: 70px;
  background: linear-gradient(45deg, #fd0000, #f0ec06);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;
export const ProjectShowCase = styled.div`
  width: 100%;
`;
export const ViewAllButton = styled(Link)`
  display: flex;
  align-items: center;
  column-gap: 10px;
  border: 1px solid white;
  border-radius: 10px;
  padding-inline: 20px;
  cursor: pointer;
  margin-inline: auto;
  color: white;
  text-decoration: none;
  div {
    transform: rotate(-125deg);
    transition: 0.3s ease-in;
  }
  &:hover div {
    transform: rotate(-90deg);
  }
`;
